import React, { useState } from "react";

import { addModuleToChapter, reorderChapterModules } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { Icon, Tooltip, Message as message } from "components";

import { ModuleDetails } from "pages/admin/content/components/ModuleDetails";
import { ModuleDetailsForm } from "pages/admin/content/components/ModuleDetailsForm";

export const ChapterDetails = ({ chapter, courseId, loadChapters, loading, setLoading }) => {
  const [showForm, setShowForm] = useState(false);
  const [activeModule, setActiveModule] = useState(null);
  const signal = useCancelAsyncOnUnmount()();

  const moveModule = ({ direction, moduleId }) => {
    const { id: chapterId, modules } = chapter;

    const index = modules.findIndex((module) => module === moduleId);

    if (direction === "UP" && index === 0) {
      return;
    }

    if (direction === "DOWN" && index === modules.length - 1) {
      return;
    }

    setLoading(true);

    const newArr = [...modules];
    const element = newArr[index];
    const delta = direction === "DOWN" ? 1 : -1;

    newArr.splice(index, 1);
    newArr.splice(index + delta, 0, element);

    reorderChapterModules({
      chapterId,
      modules: newArr,
      signal,
    })
      .then(() => {
        loadChapters();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const addModule = (v, form) =>
    addModuleToChapter({
      ...v,
      chapterId: chapter.id,
      courseId,
      signal,
    })
      .then(() => {
        form.resetFields();
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .then(() => {
        loadChapters();
        setShowForm(false);
      })
      .finally(() => {
        setLoading(false);
      });

  return (
    <div className="midi-form">
      <div style={{ display: "flex" }}>
        <h3 style={{ margin: "auto 1rem auto 0" }}>
          {chapter.modules.length} {chapter.modules.length === "1" ? "module" : "modules"} in {chapter.title}
        </h3>
        {!showForm && (
          <Tooltip placement="top" title="Add a module">
            <Icon iconName="klim/plus" size="l" className="pointer green-text icon inline" onClick={() => setShowForm(true)} />
          </Tooltip>
        )}
      </div>
      <ul style={{ margin: "2rem 0", padding: 0, listStyle: "none" }}>
        {chapter.modules.map((moduleId) => (
          <li key={moduleId} style={{ margin: "0.5rem 0 0" }}>
            <ModuleDetails
              chapterId={chapter.id}
              loadChapters={loadChapters}
              moduleId={moduleId}
              moveModule={moveModule}
              showForm={activeModule === moduleId}
              onModuleSelect={() => setActiveModule(moduleId)}
              onCloseForm={() => setActiveModule(null)}
            />
          </li>
        ))}
      </ul>
      {showForm && <ModuleDetailsForm onClose={() => setShowForm(false)} onFinish={addModule} loading={loading} />}
    </div>
  );
};
